import React, { Component } from 'react';
import './style.less';

class Logistics extends Component {
    constructor(props){
        super(props);
        this.state = {
            channel:0,
            isAllow:true,
            btnDown: []
        }
    }
    btnDown(index){
        const list = [];
        list[index] = 'down';
        this.setState({btnDown: list});
    }
    btnUp(){
        this.setState({btnDown: []});
    }
    render(){
        const { logisticsInfo, isMobile } = this.props;
        const { btnDown } = this.state;
        const items = logisticsInfo.map((ele, index) => {
            return (
                <div key={index} className="item">
                    <div className="course_info_wrap">
                        <div className="rows status">
                            {<span className="text">运单号：{!!ele.status ? ele.waybillNo : '暂无'}</span>}
                            <span className="blue">{ele.status? '已发货' : '待发货'}</span>
                        </div>
                        <div className="rows course">
                            <div className="img" style={{backgroundImage:`url(${ele.inviteAwardPicUrl})`}}></div>
                            <div className="course_info">
                                <div className={`title ${ele.inviteAwardName && ele.inviteAwardName.length >= 32 && 'long'}`}>{ele.inviteAwardName}</div>
                                <div className="num">x1</div>
                            </div>
                        </div>
                    </div>
                    <div className="break_line"></div>

                    {!!ele.addressId && 
                        <div className="address_wrap">
                            <span className="name">收货人：{ele.consignee}</span>
                            <span className="tele">{ele.consigneePhone}</span>
                            <div className="address">{`${ele.province} ${ele.city} ${ele.area} ${ele.addressDetail}`}</div>
                        </div>
                    }

                    <div className="btn_wrap">
                        <div 
                            className={`btn detail status${ele.status} ${btnDown[index]}`} 
                            onMouseUp={(e)=>{
                                const classname = e.target.className;
                                this.btnUp();
                                if(classname.indexOf('status0') > -1 ) return false;
                                window.location.href = `https://baidu.com/s?wd=${ele.waybillNo}`;
                            }}
                            onTouchEnd={(e)=>{
                                const classname = e.target.className;
                                this.btnUp();
                                if(classname.indexOf('status0') > -1 ) return false;
                                window.location.href = `https://baidu.com/s?wd=${ele.waybillNo}`;
                            }}
                            onMouseDown={(e) => {
                                const classname = e.target.className;
                                if(classname.indexOf('status0') > -1 ) return false;
                                this.btnDown(index);
                            }}
                            onTouchStart={(e) => {
                                const classname = e.target.className;
                                if(classname.indexOf('status0') > -1 ) return false;
                                this.btnDown(index);
                            }}
                            onMouseOut={this.btnUp.bind(this)}
                        >查看物流</div>
                    </div>
                </div>
            )
        })
        return(
            <div className={`container logistics ${isMobile?'':'pc'}`}>
                <div className="notice">
                    <div className="excl">!</div> 
                    <div className="text">
                   如有任何问题，请关注爱课AirCourse公众号，输入“人工”或“转人工”咨询客服
                    </div>
                </div>

                <div>{items}</div>
            </div>
        )
    }
}


export default Logistics;



// WEBPACK FOOTER //
// ./src/template/Logistics/Logistics.jsx